var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{directives:[{name:"show",rawName:"v-show",value:(_vm.appLoaded),expression:"appLoaded"}]},[_vm._t("default"),_c('v-sac-app-bar'),_c('v-main',[_c('router-view')],1),_c('v-sac-app-footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }